import classnames from 'classnames';
import { useEffect, useRef } from 'react';

import { useAccessibleInteractivity } from '../../../../../hooks';

const ParentListItem = ({ lastInteractionType, selected, name, onClick, title, toFocusForAccessibility }) => {
  const linkRef = useRef();
  useAccessibleInteractivity(linkRef, onClick);

  useEffect(() => {
    if (lastInteractionType === 'keydown') {
      toFocusForAccessibility && toFocusForAccessibility.current && toFocusForAccessibility.current.focus();
    }
  }, []);

  return (
    <li key={`${title}-${name}`} className={`parent ${selected ? 'selected' : null}`}>
      <a data-track="filter" data-track-filter-name={title} data-track-filter-option={name} ref={linkRef}>
        <i className={`icon icon-chevron-left ${selected && 'hidden'}`} /> {name}
      </a>
    </li>
  );
};

export default ParentListItem;
